// src/routes/index.ts
import { RouteConfig } from '../types';
import home from '../pages/home';
import topicThreadList from '../pages/topicThreadList';
import downloadApp from '../pages/downloadApp';
import topicDetail from '../pages/topicDetail';
import activityList from '../pages/activityList';
import feedbackList from '../pages/feedbackList';
import feedbackListSearch from '../pages/feedbackListSearch';
import myFeedbackList from '../pages/myFeedbackList';
import setPost from '../pages/setPost';
import setFeedbackPost from '../pages/setFeedbackPost';
import threadDetail from '../pages/threadDetail';
import activityDetail from '../pages/activityDetail';
import search from '../pages/search';
import user from '../pages/user';
import message from '../pages/message';
import privateMessage from '../pages/privateMessage';
import notificationsList from '../pages/notificationsList';
import privacy from '../pages/privacy';
import selfDiscipline from '../pages/selfDiscipline';
import personalInformation from '../pages/personalInformation';
import thirdPartyData from '../pages/thirdPartyData';
import houseLetter from '../pages/houseLetter';
import houseLike from '../pages/houseLike';
import houseCard from '../pages/houseCard';
import photography from '../pages/photography';
import photoExhibition from '../pages/photoExhibition';
import photographySearch from '../pages/photographySearch';
import productList from '../pages/productList';
import productDetail from '../pages/productDetail';
import goodsDetail from '../pages/goodsDetail';
import lottery from '../pages/lottery';
import lotteryRecord from '../pages/lotteryRecord';
import lotteryRecordSearch from '../pages/lotteryRecordSearch';
import h5 from '../pages/h5';
import prizeManagement from '../pages/prizeManagement';
import addressForm from '../pages/addressForm';
import vCoinRecord from '../pages/vCoinRecord';


const routes: RouteConfig[] = [
    {
        path: '/',
        component: home,
        name: '首页'
    },
    {
        path: '/topicThreadList/:id',
        component: topicThreadList,
        name: '话题帖子列表页',
    },
    {
        path: '/downloadAppEnter',
        component: downloadApp,
        name: 'APP下载页'
    },
    {
        path: '/topicDetail/:id',
        component: topicDetail,
        name: '话题详情页'
    },
    {
        path: '/activityList',
        component: activityList,
        name: '福利活动'
    },
    {
        path: '/feedbackList',
        component: feedbackList,
        name: '问题反馈列表'
    },
    {
        path: '/feedbackListSearch',
        component: feedbackListSearch,
        name: '问题反馈搜索'
    },
    {
        path: '/myFeedbackList',
        component: myFeedbackList,
        name: '我的反馈'
    },
    {
        path: '/setPost',
        component: setPost,
        name: '发布图文'
    },
    {
        path: '/setFeedbackPost',
        component: setFeedbackPost,
        name: '发布图文'
    },
    
    {
        path: '/threadDetail/:id',
        component: threadDetail,
        name: '帖子详情页'
    },
    {
        path: '/activityDetail/:id',
        component: activityDetail,
        name: '活动详情页'
    },
    {
        path: '/search',
        component: search,
        name: '搜索'
    },
    {
        path: '/user/:code',
        component: user,
        name: '个人中心'
    },
    {
        path: '/message/:code',
        component: message,
        name: '消息'
    },
    {
        path: '/privateMessage',
        component: privateMessage,
        name: '发私信'
    },
    
    {
        path: '/notificationsList/:code',
        component: notificationsList,
        name: '消息'
    },
    {
        path: '/privacy',
        component: privacy,
        name: '隐私协议'
    },
    {
        path: '/selfDiscipline',
        component: selfDiscipline,
        name: '自律公约'
    },
    {
        path: '/personalInformation',
        component: personalInformation,
        name: '个人信息收集清单'
    },
    {
        path: '/thirdPartyData',
        component: thirdPartyData,
        name: '第三方数据共享清单'
    },
    {
        path: '/houseHomeLetter',
        component: houseLetter,
        // component: downloadApp,
        name: '感谢信'
    },
    {
        path: '/houseLike',
        component: houseLike,
        // component: downloadApp,
        name: 'V粉搬新家'
    },
    {
        path: '/houseCard',
        component: houseCard,
        // component: downloadApp,
        name: '房产证'
    },
    {
        path: '/photography/:code',
        component: photography,
        // component: downloadApp,
        name: '摄影大赛'
    },
    {
        path: '/photoExhibition/:id',
        component: photoExhibition,
        name: '摄影展'
    },
    {
        path: '/photographySearch/:code?',
        component: photographySearch,
        name: '摄影搜索'
    },
    {
        path: '/productList',
        component: productList,
        name: '新品体验官'
    },
    {
        path: '/productDetail/:code',
        component: productDetail,
        name: '新品体验官'
    },
    {
        path: '/goodsDetail/:code?',
        component: goodsDetail,
        name: '商品详情'
    },
    {
        path: '/lottery/:code',
        component: lottery,
        name: '全自动抽奖'
    },
    {
        path: '/lotteryRecord',
        component: lotteryRecord,
        name: '我的抽奖'
    },
    {
        path: '/lotteryRecordSearch',
        component: lotteryRecordSearch,
        name: '搜索抽奖'
    },
    {
        path: '/prizeManagement',
        component: prizeManagement,
        name: '奖品管理'
    },
    {
        path: '/addressForm',
        component: addressForm,
        name: '填写收货地址'
    },
    {
        path: '/vCoinRecord',
        component: vCoinRecord,
        name: 'V币明细'
    },
    {
        path: '/h5/:code',
        component: h5,
        name: '嘉年华'
    },
];

export default routes;
